module.exports = __webpack_public_path__ + "img/visa.ff8f9047.png";